<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    let showDropdown = false;
    let dropdownTimeout;

    function handleMouseEnter() {
        clearTimeout(dropdownTimeout);
        showDropdown = true;
    }

    function handleMouseLeave() {
        dropdownTimeout = setTimeout(() => {
            showDropdown = false;
        }, 200);
    }

    function handleAntibodiesClick() {
        showDropdown = false;
        dispatch('select', { type: 'antibodies' });
    }

    function handleChemistryClick() {
        showDropdown = false;
        dispatch('select', { type: 'chemistry' });
    }
</script>

<div
    class="tables-dropdown-container"
    on:mouseenter={handleMouseEnter}
    on:mouseleave={handleMouseLeave}
>
    <button
        class="toolbar-button spec-button"
        title="View Tables"
        data-testid="tables-button"
    >
        <i class="fas fa-table"></i>
        <span class="button-text">Tables</span>
    </button>

    {#if showDropdown}
        <div class="dropdown-menu">
            <button
                class="dropdown-item"
                on:click={handleAntibodiesClick}
                data-testid="antibodies-option"
            >
                <i class="fas fa-dna"></i>
                <span>Antibodies</span>
            </button>
            <button
                class="dropdown-item"
                on:click={handleChemistryClick}
                data-testid="chemistry-option"
            >
                <i class="fas fa-flask"></i>
                <span>Chemistry</span>
            </button>
        </div>
    {/if}
</div>

<style>
.tables-dropdown-container {
    position: relative;
    display: inline-flex;
}

.dropdown-menu {
    position: absolute;
    top: calc(100% + var(--spacing-2));
    left: 0;
    z-index: var(--z-index-dropdown);
    min-width: 160px;
    background-color: var(--color-surface-content-spec);
    border-radius: var(--border-radius-xl);
    box-shadow: var(--shadow-dropdown);
    overflow: hidden;
}

.dropdown-item {
    display: flex;
    align-items: center;
    gap: var(--spacing-3);
    width: 100%;
    padding: var(--spacing-3) var(--spacing-4);
    font-size: var(--font-size-sm);
    color: var(--color-text-primary);
    background: none;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;
    text-align: left;
}

.dropdown-item:hover {
    background-color: var(--color-bg-hover-light);
}

.dropdown-item i {
    font-size: var(--font-size-base);
    color: var(--color-spec-600);
}

.dropdown-item span {
    font-weight: 500;
}

/* Dark mode adjustments */
:global([data-theme="dark"]) .dropdown-menu {
    background-color: var(--color-surface-content-spec);
}

:global([data-theme="dark"]) .dropdown-item i {
    color: var(--color-spec-400);
}
</style>
